module.exports = __webpack_public_path__ + "img/hz_29.3b4c6f86.jpg";